import { FC, useCallback } from "react";
import { WidgetNormalizedCostAggregation } from "@/services/cloudchipr.api";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupAggregationsSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupAggregationsSelector";
import { normalizedCostWidgetAggregationChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetAggregationChangeThunk";
import { SwitchWithTypography } from "@/components/SwitchWithTypography";

interface NormalizedCostWidgetAggregationSwitchProps {
  aggregationKey: keyof WidgetNormalizedCostAggregation;
}

export const NormalizedCostWidgetAggregationSwitch: FC<
  NormalizedCostWidgetAggregationSwitchProps
> = ({ aggregationKey }) => {
  const dispatch = useAppDispatch();

  const checked = !!useAppSelector(
    normalizedCostWidgetSetupAggregationsSelector,
  )?.[aggregationKey];

  const handleChange = useCallback(
    (newChecked: boolean) => {
      dispatch(
        normalizedCostWidgetAggregationChangeThunk({
          [aggregationKey]: newChecked,
        }),
      );
    },
    [dispatch, aggregationKey],
  );

  return (
    <SwitchWithTypography
      title={titleByKey.get(aggregationKey)}
      checked={checked}
      onChange={handleChange}
    />
  );
};

const titleByKey: Map<keyof WidgetNormalizedCostAggregation, string> = new Map([
  ["actual_total_cost", "Actual Total Cost"],
  ["average_normalized_monthly_cost", "Avg Normalized Monthly Cost"],
  ["forecasted_month_end_cost", "Forecasted Month-end Cost"],
]);
